/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type BookingClassification = "conditional" | "new_arrest" | "not_classified" | "referral" | "released" | "supervised" | "%future added value";
export type Employment = "employed" | "full_time_student" | "none" | "primary_caregiver" | "retired" | "%future added value";
export type ProspectStatus = "archived" | "enroll_or_archive" | "new" | "pending_court_decision" | "pending_interview" | "pending_recommendation" | "pending_submission" | "%future added value";
export type RecommendationReviewStatus = "approved" | "not_ready_for_review" | "pending_review" | "rejected" | "%future added value";
export type YesNo = "no" | "yes" | "%future added value";
export type YesNoUnknown = "no" | "unknown" | "yes" | "%future added value";
export type ZeroToThreeOrMore = "more" | "one" | "three" | "two" | "zero" | "%future added value";
export type BookingsGraphqlQueryVariables = {};
export type BookingsGraphqlQueryResponse = {
    readonly bookings: ({
        readonly booking: ReadonlyArray<({
            readonly id: string;
            readonly booking_defendent: {
                readonly cii_number: string | null;
                readonly local_id: string | null;
                readonly cdl_id: string | null;
                readonly name: {
                    readonly first: string;
                    readonly last: string | null;
                };
                readonly date_of_birth: string;
                readonly sex: string | null;
                readonly race: string | null;
            };
            readonly booking_info: {
                readonly booking_sid: string | null;
                readonly local_id: string | null;
                readonly booking_number: string | null;
                readonly booking_datetime: string | null;
                readonly booking_address: string | null;
                readonly booking_date: string | null;
                readonly arrest_agency: string | null;
                readonly arrested_for: string | null;
            };
            readonly booking_charges: ReadonlyArray<{
                readonly id: string;
                readonly booking_charge_sid: string | null;
                readonly booking_sid: string | null;
                readonly booking_number: string;
                readonly booking_datetime: string | null;
                readonly charge_auth_type: string | null;
                readonly charge_code_section: string;
                readonly charge_type: string | null;
                readonly charge_datetime: string | null;
                readonly charge_description: string | null;
                readonly arrest_agency: string | null;
                readonly arrest_datetime: string | null;
                readonly crime_case_number: string | null;
                readonly court_warrant_number: string | null;
            }> | null;
            readonly booking_releases: ReadonlyArray<{
                readonly charge_code_section: string;
                readonly charge_description: string;
                readonly charge_type: string;
                readonly charge_release_datetime: string;
                readonly charge_release_type: string;
                readonly warrant_number: string | null;
                readonly court_case_number: string | null;
                readonly jc_control: string | null;
                readonly created_datetime: string | null;
            }> | null;
            readonly booking_status: ({
                readonly booking_number: string;
                readonly court_appearance_datetime: string;
                readonly court_reason: string | null;
                readonly court_room: string | null;
            }) | null;
            readonly classification: BookingClassification;
            readonly imported_date: string;
            readonly comments: string | null;
            readonly is_eligible: YesNoUnknown | null;
            readonly spanish_speaker: YesNoUnknown | null;
            readonly has_wait: YesNo | null;
            readonly prospect_status: ProspectStatus | null;
            readonly participant_id: string | null;
            readonly interview_and_assessment: ({
                readonly research_factors: ({
                    readonly has_prior_misdemeanor_conviction: YesNo | null;
                    readonly has_prior_felony_conviction: YesNo | null;
                    readonly prior_violent_convictions_count: ZeroToThreeOrMore | null;
                    readonly prior_FTAs_past_two_years_count: ZeroToThreeOrMore | null;
                    readonly has_prior_FTAs_older_than_two_years: YesNo | null;
                    readonly has_prior_sentence_to_incarceration: YesNo | null;
                }) | null;
                readonly risk_factors: ({
                    readonly has_active_community_supervision: YesNo | null;
                    readonly is_charge_felony_drug_theft_or_fraud: YesNo | null;
                    readonly has_pending_charges: YesNo | null;
                    readonly has_criminal_history: YesNo | null;
                    readonly has_two_or_more_FTAs: YesNo | null;
                    readonly has_two_or_more_violent_convictions: YesNo | null;
                    readonly has_history_of_drug_abuse: YesNo | null;
                    readonly employed_at_time_of_arrest: Employment | null;
                }) | null;
                readonly completed_by: ({
                    readonly id: string;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                }) | null;
                readonly court_date: string | null;
                readonly charge_bond_type_amount_court: string | null;
                readonly instrument_completed_at: string | null;
                readonly last_updated_at: string | null;
            }) | null;
            readonly is_interview_declined: YesNo | null;
            readonly recommendation_review_status: RecommendationReviewStatus | null;
        }) | null> | null;
    }) | null;
    readonly referrals: ({
        readonly referral: ReadonlyArray<({
            readonly id: string;
            readonly cjis_referral_sid: string;
            readonly court_case_no: string;
            readonly last_name: string;
            readonly first_name: string;
            readonly middle_name: string | null;
            readonly date_of_birth: string;
            readonly event_code: string;
            readonly event_datetime: string;
            readonly event_text: string;
            readonly referral_date: string;
            readonly processed_at: string | null;
            readonly processed_by_id: string | null;
            readonly booking_id: string | null;
            readonly created_at: string;
        }) | null> | null;
    }) | null;
};
export type BookingsGraphqlQuery = {
    readonly response: BookingsGraphqlQueryResponse;
    readonly variables: BookingsGraphqlQueryVariables;
};



/*
query BookingsGraphqlQuery {
  bookings(is_eligible: unknown) {
    booking {
      id
      booking_defendent {
        cii_number
        local_id
        cdl_id
        name {
          first
          last
        }
        date_of_birth
        sex
        race
      }
      booking_info {
        booking_sid
        local_id
        booking_number
        booking_datetime
        booking_address
        booking_date
        arrest_agency
        arrested_for
      }
      booking_charges {
        id
        booking_charge_sid
        booking_sid
        booking_number
        booking_datetime
        charge_auth_type
        charge_code_section
        charge_type
        charge_datetime
        charge_description
        arrest_agency
        arrest_datetime
        crime_case_number
        court_warrant_number
      }
      booking_releases {
        charge_code_section
        charge_description
        charge_type
        charge_release_datetime
        charge_release_type
        warrant_number
        court_case_number
        jc_control
        created_datetime
      }
      booking_status {
        booking_number
        court_appearance_datetime
        court_reason
        court_room
      }
      classification
      imported_date
      comments
      is_eligible
      spanish_speaker
      has_wait
      prospect_status
      participant_id
      interview_and_assessment {
        research_factors {
          has_prior_misdemeanor_conviction
          has_prior_felony_conviction
          prior_violent_convictions_count
          prior_FTAs_past_two_years_count
          has_prior_FTAs_older_than_two_years
          has_prior_sentence_to_incarceration
        }
        risk_factors {
          has_active_community_supervision
          is_charge_felony_drug_theft_or_fraud
          has_pending_charges
          has_criminal_history
          has_two_or_more_FTAs
          has_two_or_more_violent_convictions
          has_history_of_drug_abuse
          employed_at_time_of_arrest
        }
        completed_by {
          id
          name {
            first
            last
          }
        }
        court_date
        charge_bond_type_amount_court
        instrument_completed_at
        last_updated_at
      }
      is_interview_declined
      recommendation_review_status
    }
  }
  referrals {
    referral {
      id
      cjis_referral_sid
      court_case_no
      last_name
      first_name
      middle_name
      date_of_birth
      event_code
      event_datetime
      event_text
      referral_date
      processed_at
      processed_by_id
      booking_id
      created_at
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "local_id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "name",
        "storageKey": null,
        "args": null,
        "concreteType": "PersonName",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "first",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "last",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "date_of_birth",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_sid",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_number",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_datetime",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "arrest_agency",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_code_section",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_type",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_description",
        "args": null,
        "storageKey": null
    } as any), v11 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "bookings",
            "storageKey": "bookings(is_eligible:\"unknown\")",
            "args": [
                {
                    "kind": "Literal",
                    "name": "is_eligible",
                    "value": "unknown"
                }
            ],
            "concreteType": "Pagination",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "booking",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Booking",
                    "plural": true,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking_defendent",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BookingDefendent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cii_number",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cdl_id",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sex",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "race",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking_info",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BookingInfo",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v1 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "booking_address",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "booking_date",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "arrested_for",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking_charges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BookingCharge",
                            "plural": true,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "booking_charge_sid",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                (v6 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "charge_auth_type",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "charge_datetime",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v10 /*: any*/),
                                (v7 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "arrest_datetime",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "crime_case_number",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_warrant_number",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking_releases",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BookingRelease",
                            "plural": true,
                            "selections": [
                                (v8 /*: any*/),
                                (v10 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "charge_release_datetime",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "charge_release_type",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "warrant_number",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_case_number",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "jc_control",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "created_datetime",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "booking_status",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BookingStatus",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_appearance_datetime",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_reason",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_room",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "classification",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "imported_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "comments",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_eligible",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "spanish_speaker",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "has_wait",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "prospect_status",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "participant_id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "interview_and_assessment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "InterviewAndAssessment",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "research_factors",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ResearchFactor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_prior_misdemeanor_conviction",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_prior_felony_conviction",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "prior_violent_convictions_count",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "prior_FTAs_past_two_years_count",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_prior_FTAs_older_than_two_years",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_prior_sentence_to_incarceration",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "risk_factors",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "RiskFactor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_active_community_supervision",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "is_charge_felony_drug_theft_or_fraud",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_pending_charges",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_criminal_history",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_two_or_more_FTAs",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_two_or_more_violent_convictions",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "has_history_of_drug_abuse",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "employed_at_time_of_arrest",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "completed_by",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CaseManager",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v2 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "court_date",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "charge_bond_type_amount_court",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "instrument_completed_at",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "last_updated_at",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "is_interview_declined",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "recommendation_review_status",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "referrals",
            "storageKey": null,
            "args": null,
            "concreteType": "Pagination",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "referral",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Referral",
                    "plural": true,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "cjis_referral_sid",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "court_case_no",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "last_name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "first_name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "middle_name",
                            "args": null,
                            "storageKey": null
                        },
                        (v3 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "event_code",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "event_datetime",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "event_text",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "referral_date",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "processed_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "processed_by_id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "booking_id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "BookingsGraphqlQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v11 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "BookingsGraphqlQuery",
            "argumentDefinitions": [],
            "selections": (v11 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "BookingsGraphqlQuery",
            "id": null,
            "text": "query BookingsGraphqlQuery {\n  bookings(is_eligible: unknown) {\n    booking {\n      id\n      booking_defendent {\n        cii_number\n        local_id\n        cdl_id\n        name {\n          first\n          last\n        }\n        date_of_birth\n        sex\n        race\n      }\n      booking_info {\n        booking_sid\n        local_id\n        booking_number\n        booking_datetime\n        booking_address\n        booking_date\n        arrest_agency\n        arrested_for\n      }\n      booking_charges {\n        id\n        booking_charge_sid\n        booking_sid\n        booking_number\n        booking_datetime\n        charge_auth_type\n        charge_code_section\n        charge_type\n        charge_datetime\n        charge_description\n        arrest_agency\n        arrest_datetime\n        crime_case_number\n        court_warrant_number\n      }\n      booking_releases {\n        charge_code_section\n        charge_description\n        charge_type\n        charge_release_datetime\n        charge_release_type\n        warrant_number\n        court_case_number\n        jc_control\n        created_datetime\n      }\n      booking_status {\n        booking_number\n        court_appearance_datetime\n        court_reason\n        court_room\n      }\n      classification\n      imported_date\n      comments\n      is_eligible\n      spanish_speaker\n      has_wait\n      prospect_status\n      participant_id\n      interview_and_assessment {\n        research_factors {\n          has_prior_misdemeanor_conviction\n          has_prior_felony_conviction\n          prior_violent_convictions_count\n          prior_FTAs_past_two_years_count\n          has_prior_FTAs_older_than_two_years\n          has_prior_sentence_to_incarceration\n        }\n        risk_factors {\n          has_active_community_supervision\n          is_charge_felony_drug_theft_or_fraud\n          has_pending_charges\n          has_criminal_history\n          has_two_or_more_FTAs\n          has_two_or_more_violent_convictions\n          has_history_of_drug_abuse\n          employed_at_time_of_arrest\n        }\n        completed_by {\n          id\n          name {\n            first\n            last\n          }\n        }\n        court_date\n        charge_bond_type_amount_court\n        instrument_completed_at\n        last_updated_at\n      }\n      is_interview_declined\n      recommendation_review_status\n    }\n  }\n  referrals {\n    referral {\n      id\n      cjis_referral_sid\n      court_case_no\n      last_name\n      first_name\n      middle_name\n      date_of_birth\n      event_code\n      event_datetime\n      event_text\n      referral_date\n      processed_at\n      processed_by_id\n      booking_id\n      created_at\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '6868d1f73217cd37d6e8bd04c0cc4454';
export default node;
